import React, { useEffect } from "react";
import { styled } from "@mui/system";
import { connect } from "react-redux";
import MessagesHeader from "./MessagesHeader";
import Message from "./Message";
import * as api from "../../../api";
import { setMessage } from "../../../store/actions/chatActions";
const MainContainer = styled("div")({
  height: "calc(100% - 60px)",
  width: "100%",
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  padding: "0 16px 16px",
  boxSizing: "border-box",
});

const Messages = ({ chosenChatDetails, messages, setMessage }) => {
  useEffect(() => {
    if (chosenChatDetails?.channelType === "TEXT") {
      api
        .getChannelMessages({
          serverId: chosenChatDetails.serverId,
          channelId: chosenChatDetails.id,
        })
        .then((response) => {
          if (!response.error) {
            setMessage(response.data.messages);
          }
        });
    }
  }, [chosenChatDetails, setMessage]);

  const convertDateToHumanReadable = (date, format) => {
    
    const map = {
        mm: ('0' + (date.getMonth() + 1)).slice(-2),
        dd: ('0' + date.getDate()).slice(-2),
        yy: date.getFullYear().toString().slice(-2),
        yyyy: date.getFullYear(),
    };
    
    return format.replace(/mm|dd|yy|yyyy/gi, (matched) => map[matched]);
};
  return (
    <MainContainer>
      <MessagesHeader id={chosenChatDetails?.id} name={chosenChatDetails?.name} />
      {messages.map((message, index) => {
        const sameAuthor =
          index > 0 &&
          message?.author?._id === messages[index - 1]?.author?._id;

        const sameDay =
          index > 0 &&
          convertDateToHumanReadable(new Date(message?.date), "dd/mm/yy") ===
            convertDateToHumanReadable(
              new Date(messages[index - 1]?.date),
              "dd/mm/yy"
            );
  
        return (
          <Message
            key={message._id}
            content={message.content}
            username={message?.author?.username}
            displayName={message?.author?.displayName}
            avatarUrl={message?.author?.avatarUrl}
            date={convertDateToHumanReadable(
              new Date(message.date),
              "dd/mm/yy"
            )}
            sameDay={sameDay}
            sameAuthor={sameAuthor}
          />
        );
      })}
    </MainContainer>
  );
};
const mapStoreStateToProps = ({ chat }) => {
  return {
    ...chat,
  };
};

export default connect(mapStoreStateToProps, { setMessage })(Messages);
